import { ROUTES } from '../lib/routes';
import { navigate } from '../router';
import { createLockedPanel } from '../components/ui/LockedPanel';
import { el } from '../utils/dom';

export function renderEvostDemoPage(root: HTMLElement): void {
  const wrap = el('div', {});

  wrap.append(
    el('div', { className: 'ev123-page-head ev123-page-head--sub' }, [
      el('div', { className: 'ev123-container' }, [
        el('h1', { className: 'ev123-page-head__title', text: 'EVOS-T 시설 화면' }),
        el('p', {
          className: 'ev123-page-head__lead',
          text: '시설 단위 운영 화면 확인 기능은 준비 중입니다.',
        }),
      ]),
    ])
  );

  const container = el('div', { className: 'ev123-container ev123-stack' });

  container.appendChild(
    createLockedPanel('준비 중', [
      '해당 기능은 순차적으로 제공할 예정입니다.',
      '오픈 시 이 페이지에서 안내드리겠습니다.',
    ])
  );

  const preview = el('div', { className: 'ev123-card ev123-card--future' });
  preview.append(
    el('h2', { className: 'ev123-card__title ev123-card__title--sub', text: '화면 구성 예시' }),
    el('p', {
      className: 'ev123-card__desc ev123-card__desc--sub',
      text: '연동이 완료되면 시설별 운영 지표와 충전기 상태를 한 화면에서 확인할 수 있도록 구성합니다.',
    })
  );
  const chartPh = el('div', { className: 'ev123-empty ev123-empty--sub' });
  chartPh.append(
    el('div', { className: 'ev123-empty__title', text: '표시 영역' }),
    el('p', {
      className: 'ev123-card__desc',
      text: '서비스 연계 후 실제 데이터가 표시됩니다.',
    })
  );
  preview.appendChild(chartPh);
  container.appendChild(preview);

  const foot = el('p', { className: 'ev123-page-footnote' });
  const link = el('button', { type: 'button', className: 'ev123-link-btn', text: '상담 신청' }) as HTMLButtonElement;
  link.addEventListener('click', () => navigate(ROUTES.consult));
  foot.append(document.createTextNode('도입·운영 관련 문의는 '), link, document.createTextNode('을 이용해 주세요.'));
  container.appendChild(foot);

  wrap.appendChild(container);
  root.appendChild(wrap);
}
